import { ManagerOrg } from '@/modules/manager/components/org';
import { withMotion } from '../hoc/with-motion';

const AnimatedPage = withMotion(ManagerOrg);

export const roles: string[] = [];
export const path = '/manager/:orgId';
export const element = <AnimatedPage />